module.exports = __webpack_public_path__ + "static/media/close_icon.e20bdb9d.svg";